
export default[
    {
        show(row,extra){
            return row.shbj==='1'||row.shbj==='9'
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.gotoFrame({
                title:'招标项目流程',
                url:'/Zbdl/ZbProject/detail',
                id: row.zbprocode,
            })
        }
    },{
        show(row,extra){
            return row.shbj==='1'||row.shbj==='9'
        },
        tag:'el-button',
        icon: 'el-icon-s-promotion',
        type:'text',
        text:'进入流程',
        click(row,extra){
            this.goto({
                path: '/bidding/liucheng/index',
                query: {
                    id: row.by1,
                }
            });

        }
    },{
        show(row,extra){
            return row.shbj==='1'||row.shbj==='9'
        },
        tag:'el-button',
        icon: 'el-icon-s-promotion',
        type:'text',
        text:'进入流程(旧)',
        click(row,extra){
            this.gotoFrame({
                title:'招标项目流程',
                url:'/Zbdl/ZbProject/newwfdis.do',
                q:'Q',
                id: row.by1,
            })
        }
    },{
        show(row,extra){
            return (row.shbj==='1'||row.shbj==='9')&&row.by3==='102'
        },
        tag:'el-button',
        icon: 'el-icon-download',
        type:'text',
        text:'下载真实性声明',
        click(row,extra){
            window.open(`${this.getGetters('mngUrl')}/revision/download/downzsxsm.do?zbprocode=`+row.zbprocode)

        }
    },{
        show(row,extra){
            return row.shbj!=='1'&&row.shbj!=='9'
        },
        tag:'my-btn',
        type:'del',
        text:'删除',
        click(row,extra){
            this.$post(`${this.getGetters('mngUrl')}/revision/Zbdl/ZbProject/del.json`,{
                id:row.zbprocode,
                oper:'del'
            }, (data, res) => {
                ShowMsg('删除成功','success')
                this.$emit('reload')
            });
        }
    },{
        show(row,extra){
            return row.shbj!=='1'&&row.shbj!=='9'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改',
        click(row,extra){
            this.gotoFrame({
                title:'修改招标项目',
                url:'/Zbdl/ZbProject/edit',
                id: row.zbprocode,
            })
        }
    },
]